<template>
  <div class="demo">
    <div>
      <div>dark (默认主题)</div>
      <div class="row">
        <SjNumberInput v-model="value1" class="input" />
        <SjNumberInput v-model="value1" class="input" size="mini" />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="small"
          placeholder="placeholder"
        />
        <SjNumberInput v-model="value1" class="input" size="large" />
        <SjNumberInput v-model="value1" class="input" size="middle" />
      </div>
      <div>
        disable
        <SjNumberInput v-model="value1" class="input" disabled />
      </div>
    </div>

    <div>
      <div>light</div>
      <div class="row">
        <SjNumberInput v-model="value1" class="input" theme="light" />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="mini"
          theme="light"
        />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="small"
          placeholder="placeholder"
          theme="light"
        />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="large"
          theme="light"
        />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="middle"
          theme="light"
        />
      </div>
      <div>
        disable
        <SjNumberInput v-model="value1" class="input" disabled theme="light" />
      </div>
    </div>

    <div>
      <div>background</div>
      <div class="row">
        <SjNumberInput v-model="value1" class="input" theme="background" />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="mini"
          theme="background"
        />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="small"
          placeholder="placeholder"
          theme="background"
        />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="large"
          theme="background"
        />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="middle"
          theme="background"
        />
      </div>
      <div>
        disable
        <SjNumberInput
          v-model="value1"
          class="input"
          disabled
          theme="background"
        />
      </div>
    </div>

    <div>
      <div>shadow</div>
      <div class="row">
        <SjNumberInput
          v-model="value1"
          class="input"
          theme="shadow"
          :interval="0.1"
        />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="mini"
          theme="shadow"
        />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="small"
          placeholder="placeholder"
          theme="shadow"
        />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="large"
          theme="shadow"
        />
        <SjNumberInput
          v-model="value1"
          class="input"
          size="middle"
          theme="shadow"
        />
      </div>
      <div>
        disable
        <SjNumberInput v-model="value1" class="input" disabled theme="shadow" />
      </div>
    </div>

    <div>
      <div>custom validator</div>
      <div class="row">
        <SjNumberInput
          v-model="value2"
          class="input"
          theme="shadow"
          :validator="customValidator"
        />
      </div>

      <div>custom formatter</div>
      <div class="row">
        <SjNumberInput
          v-model="value1"
          class="input"
          theme="shadow"
          :formatter="customFormatter"
        />
      </div>

      <div>custom interval</div>
      <div class="row">
        <SjNumberInput
          v-model="value1"
          class="input"
          theme="shadow"
          :interval="5"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: null,
      value2: 2,
      file: null,
      customValidator(val) {
        return val >= 1 && val <= 3;
      },
      customFormatter(val) {
        return val + "%";
      }
    };
  }
};
</script>

<style scoped lang="less">
.demo {
  .row {
    display: flex;
    align-items: center;
  }
  .input {
    margin-left: 20px;
  }
}
</style>
